<template>
  <a-layout class="idenfity-verification">
    <div class="content-base container">
      <a-button type="default" class="go-back" @click="goBack">
        <a-icon type="left" />
        Regresar
      </a-button>
      <a-row type="flex" justify="center">
        <a-col>
          <IdentityVerifyForm />
        </a-col>
      </a-row>
    </div>
  </a-layout>
</template>
<script>
import loadingMixin from "@/mixins/loadingMixin";
import { pageTitle } from "@/utils/utils";
import labels from "@/utils/labels";
import IdentityVerifyForm from "@/components/IdentityVerifyForm.vue";
export default {
  components: { IdentityVerifyForm },
  name: "IdentityVerification",
  mixins: [loadingMixin],
  metaInfo: {
    title: pageTitle(labels.profile.verifyIdentity.title),
    meta: [
      {
        name: "title",
        content: labels.appName,
      },
      {
        name: "description",
        content: labels.profile.verifyIdentity.title,
      },
    ],
  },
  data() {
    return {};
  },
  created() {
    console.log("entering identity verification");
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.idenfity-verification {
  max-width: 100% !important;
  font-family: "Roboto", sans-serif;
  background-color: transparent;
  @media screen and (max-width: $screen-mobile) {
    max-width: 100% !important;
  }
  .content-base {
    padding: 10px;

    max-width: 100% !important;

    .go-back {
      background: transparent !important;
      color: var(--btn-bg-primary);
      border-color: var(--btn-bg-primary);
      margin-bottom: 10px;
    }
  }
}
</style>
